import * as Types from '../constants/Types';
import { PAGINATION } from '../constants/Define';

const initialState = {
    onSubmitting: false,
    isFetchingUpdate: false,
    isFetchingDownload: false,
    isChecked: false,
    HMSCode: {},
    isUse: "USE",
    message: undefined,
    isSubmit: false,
    isSubmitUse: false,
    isSubmitLock: false,
    isGetItem: false,
    data: {
        pageSize: PAGINATION.pageSize,
        pageIndex: PAGINATION.pageIndex,
        totalCount: PAGINATION.totalCount,
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.VOUCHER_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.VOUCHER_CREATE_ACTION:
            return { ...state, isFetching: true, isSubmit: true };
        case Types.VOUCHER_CHECK_ACTION:
            return { ...state, isChecked: true };
        case Types.VOUCHER_UPDATE_ACTION:
            return { ...state, isFetching: true, isSubmit: true };
        case Types.VOUCHER_USED_ACTION:
            return { ...state, isFetching: true, isSubmitUse: true };
        case Types.VOUCHER_UPDATE_SUCCESS:
            return { ...state, isFetching: false, isSubmit: false };
        case Types.VOUCHER_GET_ITEM_ACTION:
            return { ...state, isFetchingGetItem: true, isGetItem: true };
        case Types.VOUCHER_GET_HISTORY_ACTION:
            return { ...state, isFetchingGetHistory: true };
        case Types.VOUCHER_LIST_SUCCESS:
            return { ...state, isFetching: false, isFetchingUpdate: false, data: { ...state.data, ...action.vouchers }, isSubmit: false };
        case Types.VOUCHER_CHECK_SUCCESS:
            // return { ...state, isFetchingUpdate: false, isChecked: false, resultCheck: action.resultCheck};
            return { ...state, isFetchingUpdate: false, isChecked: false, resultCheck: action.resultCheck, HMSCode: {} };
        case Types.VOUCHER_USED_SUCCESS:
            return { ...state, isFetchingUpdate: false, isSubmitUse: false, usedVoucher: action.usedVoucher.check, HMSCode: action.usedVoucher.HMSCode, isUse: action.usedVoucher ? "SUCCESS" : "FAIL" };
        case Types.VOUCHER_EXPORT_SUCCESS:
            return { ...state, isFetchingUpdate: false, dataEx: action.exVoucher };
        case Types.VOUCHER_GET_ITEM_SUCCESS:
            return { ...state, isFetching: false, isFetchingGetItem: false, itemVoucher: action.itemVoucher, isGetItem: false, };
        case Types.VOUCHER_CHECK_FAIL:
            return { ...state, message: action.params.message, isSubmit: false };
        case Types.VOUCHER_GET_HISTORY_SUCCESS:
            return { ...state, isFetching: false, isFetchingGetHistory: false, historyVoucher: action.historyVoucher };
        case Types.VOUCHER_RESET:
            return { ...initialState, isFetchingUpdate: false, isChecked: false, isUse: "USE" };
        case Types.VOUCHER_IMPORT_ACTION:
            return { ...state, isSubmit: true };
        case Types.VOUCHER_IMPORT_SUCCESS:
            return { ...state, importData: action.importData, importErrors: [], isSubmit: false };
        case Types.VOUCHER_IMPORT_FAILD:
            return { ...state, importErrors: action.importErrors, importData: {}, isSubmit: false };

        case Types.VOUCHER_EXPORT_EXCEL_ACTION:
            return { ...state, isFetchingDownload: true }
        case Types.VOUCHER_EXPORT_EXCEL_FAIL:
            return { ...state, isFetchingDownload: false }
        case Types.VOUCHER_EXPORT_EXCEL_SUCCESS:
            return { ...state, isFetchingDownload: false }
        case Types.VOUCHER_FAIL:
            return {
                ...state,
                isFetchingUpdate: false,
                isFetching: false,
                isChecked: false,
                isFetchingDownload: false,
                isSubmit: false,
                isSubmitUse: false,
                isSubmitLock: false,
                isGetItem: false,
            };
        default:
            return state;
    }
}
